(() => {
  // Size tables (with FOOT LENGTH MM for length-based mapping)
  const SIZE_TABLE = {
    male: [
      { EU: 40, US: 7,   UK: 6,   lengthMM: 262 },
      { EU: 41, US: 8,   UK: 7,   lengthMM: 269 },
      { EU: 42, US: 8.5, UK: 8,   lengthMM: 275 },
      { EU: 43, US: 9.5, UK: 9,   lengthMM: 282 },
      { EU: 44, US: 10,  UK: 9.5, lengthMM: 289 },
      { EU: 45, US: 11,  UK: 10.5,lengthMM: 295 },
      { EU: 46, US: 12,  UK: 11.5,lengthMM: 302 }
    ],
    female: [
      { EU: 35, US: 5,   UK: 2.5, lengthMM: 229 },
      { EU: 36, US: 5.5, UK: 3,   lengthMM: 235 },
      { EU: 37, US: 6,   UK: 4,   lengthMM: 242 },
      { EU: 38, US: 7,   UK: 5,   lengthMM: 249 },
      { EU: 39, US: 8,   UK: 6,   lengthMM: 255 },
      { EU: 40, US: 9,   UK: 6.5, lengthMM: 262 },
      { EU: 41, US: 10,  UK: 7,   lengthMM: 269 },
      { EU: 42, US: 11,  UK: 8,   lengthMM: 275 }
    ]
  };

  // Two question groups; LENGTH is last (optional)
  const QUESTION_GROUPS = [
    [
      { id: 'gender', label: 'WHAT\'S YOUR GENDER?', options: [
        { value: 'male', text: 'MALE' }, { value: 'female', text: 'FEMALE' }
      ]},
      { id: 'usualSize', label: 'WHAT\'S YOUR USUAL SHOE SIZE (EU)?', options: [] } // dynamic
    ],
    [
      { id: 'consistency', label: 'HOW CONSISTENT IS YOUR SHOE SIZE?', options: [
        { value: 'always', text: 'I ALWAYS WEAR THE SAME SIZE' },
        { value: 'sometimes_smaller', text: 'I SOMETIMES NEED A SMALLER SIZE' },
        { value: 'sometimes_larger', text: 'I SOMETIMES NEED A LARGER SIZE' }
      ]},
      { id: 'instep', label: 'HOW WOULD YOU DESCRIBE YOUR INSTEP HEIGHT?', options: [
        { value: 'low', text: 'LOW' },
        { value: 'medium_or_unknown', text: 'MEDIUM / NOT SURE' },
        { value: 'high', text: 'HIGH' }
      ]},
      { id: 'width', label: 'HOW WOULD YOU DESCRIBE YOUR FOOT WIDTH?', options: [
        { value: 'narrow', text: 'NARROW' },
        { value: 'medium_or_unknown', text: 'MEDIUM / NOT SURE' },
        { value: 'wide', text: 'WIDE' }
      ]}
    ],
    [
      { id: 'length_mm', type: 'length', label: 'WHAT IS YOUR FOOT LENGTH (MM)? (RECOMMENDED — IMPROVES ACCURACY BY 80%)' }
    ]
  ];

  // Utility: create options list for "usual size" (EU only)
  function populateUsualSizes(gender) {
    return SIZE_TABLE[gender].map(r => ({ value: String(r.EU), text: String(r.EU) }));
  }

  // Map chosen EU size to EU (direct conversion)
  function getEuFromInput(gender, sizeValue) {
    const row = SIZE_TABLE[gender].find(r => String(r.EU) === String(sizeValue));
    if (!row) throw new Error('Size not in table');
    return row.EU;
  }

  // Length → EU by midpoints
  function getEuFromLength(gender, lengthMMRaw) {
    const table = SIZE_TABLE[gender];
    if (!lengthMMRaw) return null;
    let mm = Number(lengthMMRaw);
    if (!Number.isFinite(mm)) return null;

    const min = table[0].lengthMM;
    const max = table[table.length - 1].lengthMM;
    let clamped = false;
    if (mm < min) { mm = min; clamped = true; }
    if (mm > max) { mm = max; clamped = true; }

    const mids = [];
    for (let i = 0; i < table.length - 1; i++) {
      mids.push((table[i].lengthMM + table[i + 1].lengthMM) / 2);
    }

    if (mm < mids[0]) return { eu: table[0].EU, clamped };
    if (mm >= mids[mids.length - 1]) return { eu: table[table.length - 1].EU, clamped };

    for (let i = 0; i < mids.length - 1; i++) {
      if (mm >= mids[i] && mm < mids[i + 1]) {
        return { eu: table[i + 1].EU, clamped };
      }
    }
    return { eu: table[0].EU, clamped };
  }

  // Score from non-length answers
  function scoreShift({ consistency, instep, width }) {
    let s = 0;
    if (consistency === 'sometimes_smaller') s -= 0.25;
    else if (consistency === 'sometimes_larger') s += 0.25;
    if (instep === 'low') s -= 0.25;
    else if (instep === 'high') s += 0.5;
    if (width === 'narrow') s -= 0.25;
    else if (width === 'wide') s += 0.25;
    return s;
  }

  function shiftToStepByScore(score, downThr, upThr) {
    if (score <= downThr) return -1;
    if (score >= upThr) return 1;
    return 0;
  }

  function clampEU(gender, eu) {
    const rows = SIZE_TABLE[gender];
    const minEU = rows[0].EU;
    const maxEU = rows[rows.length - 1].EU;
    return Math.min(maxEU, Math.max(minEU, eu));
  }

  function openModal(modal) { modal.hidden = false; document.body.classList.add('fitp-lock'); }
  function closeModal(modal) { modal.hidden = true; document.body.classList.remove('fitp-lock'); }

  function privacyNotice() {
    return `
      <div class="fitp-privacy">
        BY USING FIT PREDICTOR YOU AGREE TO OUR <a href="https://homies-official.com/policies/privacy-policy" target="_blank" rel="noopener">PRIVACY POLICY</a>
      </div>
    `;
  }

  function init() {
    const openBtn = document.getElementById('fit-predictor-open');
    const modal = document.getElementById('fitp-modal');
    const closeBtn = document.getElementById('fitp-close');
    const form = document.getElementById('fitp-form');

    if (!openBtn || !modal || !form) return;
    modal.hidden = true;

    let currentGroup = 0;
    let currentQuestion = 0;
    const answers = {};

    function totalQuestions() {
      return QUESTION_GROUPS.reduce((n, g) => n + g.length, 0);
    }
    function currentIndex() {
      let n = 0;
      for (let i = 0; i < currentGroup; i++) n += QUESTION_GROUPS[i].length;
      return n + currentQuestion + 1;
    }

    function renderQuestion() {
      const q = QUESTION_GROUPS[currentGroup][currentQuestion];

      // LENGTH step custom rendering
      if (q.type === 'length') {
        const hint = (answers.gender === 'male') ? '250–310' : '220–285';
        const guideUrl = (window.FITP_ASSETS && window.FITP_ASSETS.lengthGuide) || '';
        form.innerHTML = `
          <div class="fitp-progress">${currentIndex()} / ${totalQuestions()}</div>
          <h3 class="fitp-question">${q.label}</h3>
          ${guideUrl ? `
            <img class="fitp-length-illustration" src="${guideUrl}" alt="How to measure foot length">
            <div class="fitp-length-caption">MEASURE FROM HEEL TO LONGEST TOE</div>
          ` : '' }
          <div class="fitp-length-row">
            <input type="number" inputmode="numeric" min="1" step="1" placeholder="${hint}" class="fitp-length-input" />
            <div class="fitp-length-actions">
              <button type="button" class="fitp-option fitp-solid" data-action="use">CONTINUE</button>
              <button type="button" class="fitp-back" data-action="skip">SKIP</button>
            </div>
          </div>
          ${currentIndex() > 1 ? '<button type="button" class="fitp-back" data-action="back">← BACK</button>' : ''}
          ${privacyNotice()}
        `;

        const input = form.querySelector('.fitp-length-input');
        const onChoose = (useValue) => {
          const val = input.value.trim();
          if (useValue && val) answers.length_mm = val;
          else delete answers.length_mm;
          forward();
        };

        form.querySelector('[data-action="use"]').addEventListener('click', () => onChoose(true));
        form.querySelector('[data-action="skip"]').addEventListener('click', () => onChoose(false));
        const backBtn = form.querySelector('[data-action="back"]');
        if (backBtn) backBtn.addEventListener('click', () => goBack());
        return;
      }

      // Standard option buttons step
      let options = q.options;
      if (q.id === 'usualSize' && answers.gender) {
        options = populateUsualSizes(answers.gender);
      }

      form.innerHTML = `
        <div class="fitp-progress">${currentIndex()} / ${totalQuestions()}</div>
        <h3 class="fitp-question">${q.label}</h3>
        <div class="fitp-options">
          ${options.map(opt => `<button type="button" class="fitp-option" data-value="${opt.value}">${opt.text}</button>`).join('')}
        </div>
        ${currentIndex() > 1 ? '<button type="button" class="fitp-back" data-action="back">← BACK</button>' : ''}
        ${privacyNotice()}
      `;

      form.querySelectorAll('.fitp-option').forEach(btn => {
        btn.addEventListener('click', () => {
          answers[q.id] = btn.dataset.value;
          forward();
        });
      });
      const backBtn = form.querySelector('[data-action="back"]');
      if (backBtn) backBtn.addEventListener('click', () => goBack());
    }

    function forward() {
      currentQuestion++;
      if (currentQuestion >= QUESTION_GROUPS[currentGroup].length) {
        currentGroup++;
        currentQuestion = 0;
      }
      if (currentGroup >= QUESTION_GROUPS.length) {
        showResult();
      } else {
        renderQuestion();
      }
    }

    function goBack() {
      currentQuestion--;
      if (currentQuestion < 0) {
        currentGroup--;
        currentQuestion = QUESTION_GROUPS[currentGroup].length - 1;
      }
      const prev = QUESTION_GROUPS[currentGroup][currentQuestion];
      delete answers[prev.id];
      renderQuestion();
    }

    function showResult() {
      const { gender, usualSize, consistency, instep, width, length_mm } = answers;

      const baseEU = getEuFromInput(gender, usualSize);
      const scoreOther = scoreShift({ consistency, instep, width });

      let eu = baseEU;
      let stepApplied = 0;

      if (length_mm) {
        const got = getEuFromLength(gender, length_mm);
        if (got) {
          const euLen = got.eu;
          const clamped = got.clamped;

          if (Math.abs(euLen - baseEU) >= 2) {
            eu = clampEU(gender, euLen);
            stepApplied = 0;
          } else {
            const step = shiftToStepByScore(scoreOther, -0.75, 0.75);
            eu = clampEU(gender, euLen + step);
            stepApplied = step;
          }
        }
      } else {
        const step = shiftToStepByScore(scoreOther, -0.5, 0.5);
        eu = clampEU(gender, baseEU + step);
        stepApplied = step;
      }

      form.innerHTML = `
        <div class="fitp-result">
          <div class="fitp-hl">RECOMMENDED SIZE (EU): <strong>${eu}</strong></div>
        </div>
        <button type="button" class="fitp-restart">START OVER</button>
        ${privacyNotice()}
      `;

      form.querySelector('.fitp-restart').addEventListener('click', () => {
        currentGroup = 0;
        currentQuestion = 0;
        Object.keys(answers).forEach(k => delete answers[k]);
        renderQuestion();
      });
    }

    // Open/close handlers (anchor trigger -> prevent default)
    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      currentGroup = 0;
      currentQuestion = 0;
      for (const k of Object.keys(answers)) delete answers[k];
      renderQuestion();
      openModal(modal);
    });
    closeBtn.addEventListener('click', () => closeModal(modal));
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(modal); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) closeModal(modal); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();